module.exports = __webpack_public_path__ + "img/tra_bg_rol@2x.09adbab1.png";